import * as Models from "../Models";
import * as Services from "../Services";
import * as Routes from "../Routes";
import * as Shared from "../Shared";

export interface IContractOptionTileDirectiveScope extends ng.IScope {
    contractOptionTileDirective: ContractOptionTileDirective;
    epcCalculationOptions: Models.CostCalculation.EpcCalculationOption.IOpportunityAssociatedEpcCalculationOption[];
}

export class ContractOptionTileDirective implements ng.IDirective {
    public restrict = "E";
    public scope = {
        epcCalculationOptions: "=",
        canViewEpcCostsAndTotals: "=",
        massachusettsCustomer: "=",
        product: "=",
        selectEpcCalculation: "&"
    };

    public template = require("./contract-option-tile.html");

    public $scope: IContractOptionTileDirectiveScope;
    public $state: angular.ui.IStateService;

    public epcCalculationOptions: Models.CostCalculation.EpcCalculationOption.IOpportunityAssociatedEpcCalculationOption[];
    public canViewEpcCostsAndTotals: boolean;
    public massachusettsCustomer:boolean;
    public selectEpcCalculation: any;

    public static $inject = [
        "$state"
    ];

    constructor($state: angular.ui.IStateService) {
        this.$state = $state;
    }

    public link = (
        $scope: IContractOptionTileDirectiveScope,
        elm: any,
        attr: any,
        ctrl: any
    ): void => {
        $scope.contractOptionTileDirective = this;
        this.$scope = $scope;
    };
}